import ProductRoutes, { PRODUCTS_BASE_ROUTES } from './ProductRoutes';
import ProductSubRoutes from './ProductSubRoutes';

export { ProductRoutes, PRODUCTS_BASE_ROUTES, ProductSubRoutes };
